export default "__VITE_ASSET__CJ3aBFhR__"